/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackAddedToPurchasedAlbumNotificationActionData } from './TrackAddedToPurchasedAlbumNotificationActionData';
import {
    TrackAddedToPurchasedAlbumNotificationActionDataFromJSON,
    TrackAddedToPurchasedAlbumNotificationActionDataFromJSONTyped,
    TrackAddedToPurchasedAlbumNotificationActionDataToJSON,
} from './TrackAddedToPurchasedAlbumNotificationActionData';

/**
 * 
 * @export
 * @interface TrackAddedToPurchasedAlbumNotificationAction
 */
export interface TrackAddedToPurchasedAlbumNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPurchasedAlbumNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPurchasedAlbumNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof TrackAddedToPurchasedAlbumNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {TrackAddedToPurchasedAlbumNotificationActionData}
     * @memberof TrackAddedToPurchasedAlbumNotificationAction
     */
    data: TrackAddedToPurchasedAlbumNotificationActionData;
}

/**
 * Check if a given object implements the TrackAddedToPurchasedAlbumNotificationAction interface.
 */
export function instanceOfTrackAddedToPurchasedAlbumNotificationAction(value: object): value is TrackAddedToPurchasedAlbumNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function TrackAddedToPurchasedAlbumNotificationActionFromJSON(json: any): TrackAddedToPurchasedAlbumNotificationAction {
    return TrackAddedToPurchasedAlbumNotificationActionFromJSONTyped(json, false);
}

export function TrackAddedToPurchasedAlbumNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackAddedToPurchasedAlbumNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': TrackAddedToPurchasedAlbumNotificationActionDataFromJSON(json['data']),
    };
}

export function TrackAddedToPurchasedAlbumNotificationActionToJSON(value?: TrackAddedToPurchasedAlbumNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': TrackAddedToPurchasedAlbumNotificationActionDataToJSON(value.data),
    };
}

